export default function removeQueryParam(url, paramPrefix) {
  if (!url.includes('?')) return url // No query params to remove

  const urlObj = new URL(url, 'http://dummy.com') // Base needed for relative URLs
  const params = urlObj.searchParams

  // Collect keys that start with the given prefix
  const keysToRemove = []
  params.forEach((_, key) => {
    if (key.startsWith(paramPrefix)) {
      keysToRemove.push(key)
    }
  })

  // Remove them
  keysToRemove.forEach((key) => params.delete(key))

  // Return the updated URL without modifying its base/path
  return urlObj.pathname + urlObj.search
}
